import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  AUTH_LOGIN_ROUTE_SEGMENTS,
  AUTH_REGISTER_ROUTE_SEGMENTS,
  AUTH_USER_DETAILS_UPDATE
} from '@tix/auth/constants';
import { TixLoginComponent } from './login/login.component';
import { TixRegisterComponent } from './register/register.component';
import { TixAuthorizedGuard, TixUnauthorizedGuard } from '@tix/auth/guards';
import { PendingChangesGuard } from '@tix/shared/ui/components';
import { TixRequestPasswordResetComponent } from './request-password-reset/request-password-reset.component';
import { TixResetPasswordComponent } from './reset-password/reset-password.component';
import { RequestAccountDeletePageComponent } from './request-account-delete-page/request-account-delete-page.component';
import { LoginWithRedirectComponent } from './login-with-redirect/login-with-redirect.component';
import { ReleaseSwitcherComponent } from './release-switcher/release-switcher.component';

const routes: Routes = [
  {
    path: AUTH_LOGIN_ROUTE_SEGMENTS.join('/'),
    component: TixLoginComponent,
    canActivate: [TixUnauthorizedGuard],
    data: {
      isLoginRoute: true
    }
  },
  {
    path: AUTH_REGISTER_ROUTE_SEGMENTS.join('/'),
    component: TixRegisterComponent,
    canActivate: [TixUnauthorizedGuard],
    data: {
      isRegisterRoute: true
    }
  },
  {
    path: AUTH_USER_DETAILS_UPDATE.join('/'),
    component: TixRegisterComponent,
    canDeactivate: [PendingChangesGuard],
    canActivate: [TixAuthorizedGuard],
    data: {
      isRegisterRoute: false
    }
  },
  {
    path: 'auth/request-password-reset',
    component: TixRequestPasswordResetComponent,
    canActivate: [TixUnauthorizedGuard],
    data: {
      isRegisterRoute: false
    }
  },
  {
    path: 'auth/reset-password',
    component: TixResetPasswordComponent,
    canActivate: [TixUnauthorizedGuard],
    data: {
      isRegisterRoute: false
    }
  },
  {
    path: 'auth/request-account-delete',
    component: RequestAccountDeletePageComponent,
    data: {
      isRegisterRoute: false
    }
  },
  {
    path: 'auth/login-with-redirect',
    component: LoginWithRedirectComponent
  },
  {
    path: 'my-profile',
    component: TixRegisterComponent,
    canDeactivate: [PendingChangesGuard],
    canActivate: [TixAuthorizedGuard],
    data: {
      isRegisterRoute: false,
      isCompanyProfile: true
    }
  },
  {
    path: 'release-switcher',
    component: ReleaseSwitcherComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TixAuthPagesRoutingModule {}
